import { ChevronDown, ChevronUp, SmilePlus } from "lucide-react";
import React from "react";
import { Button, Popover, PopoverContent, PopoverTrigger } from "randmarcomps";

const parseEmojiCodePoint = (value: string) => {
  const trimmed = value.trim();
  const entityMatch = /^&#(\d+);$/.exec(trimmed);
  if (entityMatch) {
    const parsed = Number(entityMatch[1]);
    return Number.isFinite(parsed) ? parsed : null;
  }

  const firstCodePoint = trimmed.codePointAt(0);
  return typeof firstCodePoint === "number" ? firstCodePoint : null;
};

const renderEmoji = (emoji: string) => {
  const className = "w-full justify-self-center text-center text-base";
  const codePoint = parseEmojiCodePoint(emoji);
  const resolved =
    codePoint === 9989 ? 9989 :
    codePoint === 9996 ? 9996 :
    codePoint === 11088 ? 11088 :
    codePoint === 127774 ? 127774 :
    codePoint === 128161 ? 128161 :
    codePoint === 128170 ? 128170 :
    codePoint === 129505 ? 129505 :
    codePoint === 128338 ? 128338 :
    codePoint === 10068 ? 10068 :
    codePoint === 128681 ? 128681 :
    codePoint === 127384 ? 127384 :
    codePoint === 9940 ? 9940 :
    129300;

  return <div className={className}>{String.fromCodePoint(resolved)}</div>;
};

interface IProps {
  children: React.ReactNode;
  buttonText?: string;
  size?: "small" | "medium" | "large";
  variant?: "default" | "secondary" | "outline" | "ghost";
  icon?: React.ReactNode;
  alignTop?: boolean;
  emoji?: string;
  className?: string;
}

const ButtonWithActions = ({
  children,
  buttonText,
  size = "small",
  icon,
  variant = "outline",
  alignTop,
  emoji,
  className,
}: IProps) => {
  const randmarSize = size === "small" ? "sm" : size === "large" ? "lg" : "default";

  return (
    <Popover>
      <PopoverTrigger asChild>
        {
          buttonText === "Add Reaction" ?
            <Button variant="ghost" size="icon">{emoji ? renderEmoji(emoji) : <SmilePlus />}</Button>
            :
            <Button
              variant={variant}
              size={randmarSize}
              className={["inline-flex items-center gap-2 rounded-xl", className].filter(Boolean).join(" ")}
            >
              {
                buttonText &&
                <span>{buttonText}</span>
              }
              {
                icon ||
                (alignTop ? <ChevronUp /> : <ChevronDown />)
              }
            </Button>
        }
      </PopoverTrigger>
      <PopoverContent
        side={alignTop ? "top" : "bottom"}
        align="end"
        className="w-72 rounded-2xl border border-border bg-popover p-0 shadow-lg"
      >
        {children}
      </PopoverContent>
    </Popover>
  )
}

export default ButtonWithActions;
